import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import IngredientInputs from "../../../component/inventory/ingredient/IngredientInputs";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import { validateIngredients } from "../../../services/inventory/ingredient.service";
import IngredientInputSkeleton from "../../../component/inventory/ingredient/IngerdientInputSkeleton";
import CustomLoader from "../../../component/menu/CustomLoader";

export default function IngredientEdit() {
  const { restaurantId, user, showNotification, setNetworkCall } = useUserStore();
  const { ingredientId } = useParams();
  const navigate = useNavigate();
  const [ingredients, setIngredients] = useState([
    {
      id: crypto.randomUUID(),
      name: "",
      unit: "",
      minStock: "",
    },
  ]);
  const [ingredientLoading, setIngredientLoading] = useState(true);

  useEffect(() => {
    if (ingredientId) {
      getIngredientDetails(ingredientId);
    }
  }, [ingredientId]);

  async function getIngredientDetails(ingredientId) {
    try {
      const res = await ApiService.INVENTORY_INGREDIENT_DETAIL_WITH_ID(ingredientId, user.token.token);
      if (res.code !== 200) {
        showNotification(res.data.message);
        setIngredientLoading(false);
        return;
      }
      const { payload } = res;
      const { record } = payload;
      const { restaurantId, ...recordWithoutRetaurantId } = record;
      setIngredients([recordWithoutRetaurantId]);
      setIngredientLoading(false);
    } catch (err) {
      showNotification(err.response.data.message);
      setIngredientLoading(false);
      return;
    }
  }

  async function ingredientUpsert(ingredients) {
    if (ingredients.length < 1) return;
    setNetworkCall(true);
    const payload = {
      restaurantId: restaurantId,
      ingredients: ingredients,
    };

    try {
      const res = await ApiService.INVENTORY_INGREDIENT_UPSERT(payload, user.token.token);
      if (res.code !== 200) {
        setNetworkCall(false);
        getIngredientDetails(ingredientId);
        showNotification(res.data.message);
        return;
      }
      setNetworkCall(false);
      showNotification("Ingredient updated successfully!", false);
      return navigate("/inventory/ingredients");
    } catch (err) {
      setNetworkCall(false);
      showNotification(err.response.data.message);
      return;
    }
  }

  function onHandleCancel() {
    navigate("/inventory/ingredients");
  }

  function onHandleUpdate() {
    if (validateIngredients(ingredients)) {
      ingredientUpsert(ingredients);
    }
  }

  function updateIngredientField(fieldName, fieldValue, ingredientId) {
    if (fieldName === "name") {
      setIngredients((prev) =>
        prev.map((item) => (item.id === ingredientId ? { ...item, [fieldName]: fieldValue } : item))
      );
    }
    if (fieldName === "unit") {
      setIngredients((prev) =>
        prev.map((item) => (item.id === ingredientId ? { ...item, [fieldName]: fieldValue } : item))
      );
    }
    if (fieldName === "minStock") {
      setIngredients((prev) =>
        prev.map((item) => (item.id === ingredientId ? { ...item, [fieldName]: fieldValue } : item))
      );
    }
  }

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_1"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent title={"Edit Ingredient"} listRoute="/inventory/ingredients" />
          </div>

          <div className="w-full h-auto min-h-[50vh] bg-white rounded-[12px] pl-[37px] pt-[50px]">
            {/* item header */}
            <div className="flex items-center space-x-3 font-p_medium text-xs leading-[13px] text-black mb-[10px]">
              <p className="w-[300px]">
                Item name <span className="text-red-500">*</span>
              </p>
              <p className="w-[130px]">
                Item Unit <span className="text-red-500">*</span>
              </p>
              <p className="w-[300px]">
                Minimum Stocks <span className="text-red-500">*</span>
              </p>
            </div>
            {ingredients.map((ing, idx) => (
              <div className="w-full flex items-center gap-x-[60px] mb-3" key={ing.id}>
                {ingredientLoading ? (
                  <IngredientInputSkeleton />
                ) : (
                  <IngredientInputs
                    records={{ ingId: ing.id, ingredients, setIngredients }}
                    ingredient={ingredients[0]}
                    updateIngredientField={updateIngredientField}
                  />
                )}
              </div>
            ))}

            <div className="flex items-center space-x-3 pt-[76px]">
              <button
                onClick={onHandleCancel}
                className="font-bold w-[100px] h-[42px] bg-[#FCBD10] text-black rounded-[5px] text-base leading-[16px]"
              >
                Cancel
              </button>
              <button
                onClick={onHandleUpdate}
                className="font-bold w-[100px] h-[42px] bg-black text-white rounded-[5px] text-base leading-[16px] flex items-center justify-center"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
